import script from "./SelectForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectForm.vue?vue&type=script&setup=true&lang=js"

import "./SelectForm.vue?vue&type=style&index=0&id=5237d8ae&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5237d8ae"]])

export default __exports__